import { createSelector } from 'reselect'
import { API_URL_CONFIGURATION } from '../../../constants/apiUrls'
import pendingRequestsSelector from './pendingRequestsSelector'
import requestIsPending from './helpers/requestIsPending'

const configurationRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_CONFIGURATION),
)

export default configurationRequestIsPendingSelector
